<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link
            :to="{ path: '/setup/media-pricing/event' }"
            class="vx-row"
          >
            <feather-icon
              class="ml-2"
              icon="ArrowLeftIcon"
              svgClasses="text-dark"
            />
            <h4>{{ $t("setup.label.Prices") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="vx-row" v-if="!editToggle">
      <vx-card>
        <div class="vx-row less-padding">
          <div class="vx-col w-4/5 less-padding">
            <div class="vx-row border-left heading">
              <div class="vx-col w-full sm:w-1/2 md:w-1/5">
                {{ $t("setup.label.CustomerType") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5">
                {{ $t("setup.label.FormatType") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5">
                {{ $t("setup.label.DiscountCode") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5">
                {{ $t("setup.label.OptType") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5">
                {{ $t("setup.label.Currency") }}
              </div>
            </div>
          </div>
          <div class="vx-col w-1/5 less-padding">
            <div class="vx-row border-left heading" style="height: 100%">
              <div class="vx-col w-full md:w-1/2">
                {{ $t("setup.label.Amount") }}
              </div>

              <div class="vx-col w-full md:w-1/2">
                {{ $t("setup.label.Actions") }}
              </div>
            </div>
          </div>
        </div>

        <div class="vx-row less-padding">
          <div class="vx-col w-4/5 less-padding">
            <div class="vx-row border-left py-2" style="height: 100%">
              <div class="vx-col w-full md:w-1/5">
                <v-select
                  label="type"
                  v-model="customerType"
                  :options="priceTemplateData.clientTypes"
                  :reduce="(obj) => obj.id"
                  :placeholder="$t('placeholder.label.SelectOne')"
                >
                  <template v-slot:option="option">{{ option.type }}</template>
                </v-select>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5">
                <v-select
                  label="formatType"
                  v-model="formatType"
                  :options="priceTemplateData.format"
                  :reduce="(obj) => obj.formatType"
                  :placeholder="$t('placeholder.label.SelectOne')"
                >
                  <template v-slot:option="option">{{
                    option.formatType
                  }}</template>
                </v-select>
              </div>
              <div class="vx-col w-full md:w-1/5">
                <v-select
                  label="discountCode"
                  v-model="discountCode"
                  :options="priceTemplateData.discountdata"
                  :reduce="(obj) => obj.id"
                  :placeholder="$t('placeholder.label.SelectOne')"
                >
                  <template v-slot:option="option">{{
                    option.discountCode
                  }}</template>
                </v-select>
              </div>
              <div class="vx-col w-full md:w-1/5">
                <v-select
                  label="value"
                  v-model="optType"
                  :options="priceTemplateData.optTypes"
                  :reduce="(obj) => obj.value"
                  :placeholder="$t('placeholder.label.SelectOne')"
                >
                  <template v-slot:option="option">{{ option.value }}</template>
                </v-select>
              </div>
              <div class="vx-col w-full md:w-1/5">
                <v-select
                  label="code"
                  v-model="currency"
                  class="w-full"
                  :reduce="(obj) => obj.id"
                  :options="priceTemplateData.currencydata.currencyOptions"
                  :placeholder="$t('placeholder.label.SelectOne')"
                >
                  <template v-slot:option="option"
                    >{{ option.code }}--{{ option.name }}</template
                  >
                </v-select>
              </div>
            </div>
          </div>
          <div class="vx-col w-1/5 less-padding">
            <div class="vx-row border-left py-2" style="height: 100%">
              <div class="vx-col w-full md:w-1/2">
                <vs-input
                  class="w-full mb-2 font-semibold padding-zero"
                  v-model="amount"
                />
              </div>
              <div class="vx-col w-full md:w-1/2">
                <div class="whitespace-no-wrap p-3" style="cursor: pointer">
                  <feather-icon
                    icon="PlusIcon"
                    :title="$t('setup.label.Add')"
                    class="icon_row"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current cursor"
                    @click.stop="addData()"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="margin-bottom my-3"></div>

        <div class="vx-row less-padding">
          <div class="vx-col w-4/5 less-padding">
            <div class="vx-row border-left heading">
              <div class="vx-col w-full sm:w-1/2 md:w-1/5">
                {{ $t("setup.label.CustomerType") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5">
                {{ $t("setup.label.FormatType") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5">
                {{ $t("setup.label.DiscountCode") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5">
                {{ $t("setup.label.OptType") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5">
                {{ $t("setup.label.Currency") }}
              </div>
            </div>
          </div>
          <div class="vx-col w-1/5 less-padding">
            <div class="vx-row border-left heading" style="height: 100%">
              <div class="vx-col w-full md:w-1/2">
                {{ $t("setup.label.Amount") }}
              </div>
              <div class="vx-col w-full md:w-1/2">
                {{ $t("setup.label.Actions") }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="vx-row less-padding"
          :key="index"
          :data="priceEl"
          v-for="(priceEl, index) in priceTemplateData.EventPricingData"
        >
          <div class="vx-col w-4/5 less-padding">
            <div class="vx-row border-left py-2" style="height: 100%">
              <div class="vx-col w-full sm:w-1/2 md:w-1/5">
                <v-select
                  label="type"
                  v-model="priceEl.clientType"
                  :options="priceTemplateData.clientTypes"
                  :reduce="(obj) => obj.type"
                  :placeholder="$t('placeholder.label.SelectOne')"
                >
                  <template v-slot:option="option">{{ option.type }}</template>
                </v-select>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5">
                <v-select
                  label="formatType"
                  v-model="priceEl.formatType"
                  :options="priceTemplateData.format"
                  :reduce="(obj) => obj.formatType"
                  :placeholder="$t('placeholder.label.SelectOne')"
                >
                  <template v-slot:option="option">{{
                    option.formatType
                  }}</template>
                </v-select>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5">
                <v-select
                  label="discountCode"
                  v-model="priceEl.discount"
                  :options="priceTemplateData.discountdata"
                  :reduce="(obj) => obj.discountCode"
                  :placeholder="$t('placeholder.label.SelectOne')"
                >
                  <template v-slot:option="option">{{
                    option.discountCode
                  }}</template>
                </v-select>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5">
                <v-select
                  label="value"
                  v-model="priceEl.optType"
                  :options="priceTemplateData.optTypes"
                  :reduce="(obj) => obj.value"
                  :placeholder="$t('placeholder.label.SelectOne')"
                >
                  <template v-slot:option="option">{{ option.value }}</template>
                </v-select>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/5">
                <v-select
                  label="code"
                  v-model="priceEl.currencyCode"
                  :options="priceTemplateData.currencydata.currencyOptions"
                  ::placeholder="$t('placeholder.label.SelectOne')"
                >
                  <template v-slot:option="option"
                    >{{ option.code }}--{{ option.name }}</template
                  >
                </v-select>
              </div>
            </div>
          </div>
          <div class="vx-col w-1/5 less-padding">
            <div class="vx-row border-left py-2" style="height: 100%">
              <div class="vx-col w-full md:w-1/2">
                <vs-input
                  class="w-full mb-2 font-semibold padding-zero"
                  v-model="priceEl.price"
                />
              </div>
              <div class="vx-col w-full flex md:w-1/2">
                <div class="whitespace-no-wrap p-3" style="cursor: pointer">
                  <feather-icon
                    class="icon_row text-success icon_row"
                    icon="CheckIcon"
                    svgClasses="w-5 h-5 text-success stroke-current cursor mr-4"
                    color="success"
                    :title="$t('setup.label.Save')"
                    type="border"
                    @click.stop="updatePriceData(priceEl)"
                    size="small"
                  ></feather-icon>
                  <feather-icon
                    class="icon_row text-danger icon_row"
                    icon="TrashIcon"
                    svgClasses="w-5 h-5 text-danger stroke-current cursor"
                    color="danger"
                    :title="$t('setup.label.Delete')"
                    type="border"
                    @click.stop="deleteEventPrice(priceEl.id)"
                    size="small"
                  ></feather-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>

    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('setup.label.AddDiscount')"
        :active.sync="discountPopup"
        class="popup-close"
      >
        <form>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
            <div class="vx-col sm:w-full w-full">
              <small class="font-semibold">{{
                $t("setup.label.DiscountCode")
              }}</small>
              <v-select
                label="discountCode"
                v-model="selectedDiscount"
                :options="productDiscounts"
                :placeholder="$t('placeholder.label.SelectOne')"
                :reduce="(name) => name.discountId"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full"
              />
            </div>
          </div>
          <div class="flex justify-center gap-6 mt-8 mb-4">
            <vs-button
              icon-pack="feather"
              type="border"
              icon="icon-x"
              @click="discountPopup = false"
              >{{ $t("customers.label.cancel") }}</vs-button
            >
            <vs-button
              icon-pack="feather"
              @click="addUpdateDiscount"
              icon="icon-search"
              >{{ $t("setup.label.Submit") }}</vs-button
            >
          </div>
        </form>
      </vs-popup>
    </div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";

export default {
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      customertype: "",
      formatType: "",
      discountCode: "",
      optType: "",
      currency: "",
      amount: "",
    };
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      priceTemplateData: (state) => state.mediaDetails.addPriceTemplate,
    }),
  },
  methods: {
    async getPriceTemplateData(id) {
      try {
        await this.$store.dispatch("mediaDetails/eventPriceTemplateAction", id);
      } catch (error) {
        this.$toasted.error(error.message);
      }
    },
    async addData() {
      let Payload = {
        eventId: this.id,
        clientType: this.customerType,
        formatType: this.formatType,
        discountId: this.discountCode,
        optType: this.optType,
        currencyId: this.currency,
        price: this.amount,
        locale: "en",
      };

      try {
        await this.$store.dispatch("mediaDetails/addEventPriceAction", {
          id: this.id,
          data: Payload,
        });
        await this.getPriceTemplateData(this.id);
        this.customerType = "";
        this.formatType = "";
        this.discountCode = "";
        this.optType = "";
        this.currency = "";
        this.amount = "";
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Price added successfully!",
          type: "success",
        });
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async deleteEventPrice(id) {
      await this.$store.dispatch("mediaDetails/deleteEventPriceAction", id);
      this.getPriceTemplateData(this.id);
    },
    async updatePriceData(priceDetail) {
      let matchingClientType = this.priceTemplateData.clientTypes.find(
        (clientType) => clientType.type === priceDetail.clientType
      );
      if (matchingClientType) {
        priceDetail.clientType = matchingClientType.id;
      }
      let Payload = {
        id: priceDetail.id,
        eventId: priceDetail.eventId,
        formatType: priceDetail.formatType,
        optType: priceDetail.optType,
        clientTypeId: priceDetail.clientTypeId,
        discount: priceDetail.discount,
        price: priceDetail.price,
        eventName: priceDetail.eventName,
        clientType: priceDetail.clientType,
        discountId: priceDetail.discountId,
        currencyId: priceDetail.currencyId,
        currencyCode: priceDetail.currencyCode,
        locale: "en",
      };

      try {
        await this.$store.dispatch("mediaDetails/updateEventPriceAction", {
          id: priceDetail.id,
          data: Payload,
        });
        await this.getPriceTemplateData(this.id);

        this.$swal({
          title: "Success",
          icon: "success",
          text: "Price updated successfully!",
          type: "success",
        });
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
  },
  async mounted() {
    this.id = this.$route.params.id;
    this.getPriceTemplateData(this.id);
  },
};
</script>

<style scoped>
.padding-zero {
  padding-top: 0px;
}
::v-deep .vs__selected-options {
  overflow: hidden;
  width: 100px;
  font-size: 12px;
  display: block;
}
.price-table >>> .vs-input--input.normal {
  width: 80px;
  font-size: 12px;
}
::v-deep .vs--searchable .vs__dropdown-toggle {
  height: 40px;
}
::v-deep .vs-table-text {
  display: block;
}
::v-deep .vs__selected {
  text-wrap: nowrap;
}
.less-padding .vx-row > .vx-col {
  padding: 0 4px;
}
::v-deep .vs-table--not-data {
  display: none;
}
</style>
<style lang="scss" scoped>
.w-13 {
  width: 8.5%;
  padding: 0 4px;
  max-width: 90px;
  &:last-child {
    width: 4%;
  }
}
.border-left {
  border-bottom: 1px solid rgba(var(--vs-primary), 0.3);
  div {
    &:not(:first-child) {
      border-left: 1px solid rgba(var(--vs-primary), 0.3);
    }
    &:nth-child(6) {
      border-right: 1px solid rgba(var(--vs-primary), 0.3);
    }
  }
}
.heading {
  font-weight: 600;
  font-size: 0.9rem;
  div {
    padding: 0.5rem 5px !important;
  }
}
.margin-bottom {
  width: 100%;
  border-bottom: 1px solid #777;
  margin-bottom: 20px;
}
</style>
